// src/services/admin/adminUserSchool.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminUserSchoolApi = createApi({
  reducerPath: "adminUserSchoolApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/adminUserSchool`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminUserSchool"],
  endpoints: (builder) => ({
    getAllowedAdminTypes: builder.query({
      query: () => "/admin-types/allowed",
    }),
    getAllAdminUserSchool: builder.query({
      query: () => "/",
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "AdminUserSchool",
                id,
              })),
              { type: "AdminUserSchool", id: "PARTIAL-LIST" },
            ]
          : [{ type: "AdminUserSchool", id: "PARTIAL-LIST" }],
    }),
    getAdminUserSchoolById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "AdminUserSchool", id }],
    }),
    getAdminSchools: builder.query({
      query: () => "/admin-schools",
    }),
    createAdminUserSchool: builder.mutation({
      query: (newRecord) => ({
        url: "/",
        method: "POST",
        body: newRecord,
      }),
      invalidatesTags: [{ type: "AdminUserSchool", id: "PARTIAL-LIST" }],
    }),
    updateAdminUserSchool: builder.mutation({
      query: ({ id, ...updatedFields }) => ({
        url: `/${id}`,
        method: "PUT",
        body: updatedFields,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "AdminUserSchool", id },
      ],
    }),
    deleteAdminUserSchool: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "AdminUserSchool", id }],
    }),
  }),
});

export const {
  useGetAllowedAdminTypesQuery,
  useGetAllAdminUserSchoolQuery,
  useGetAdminUserSchoolByIdQuery,
  useGetAdminSchoolsQuery,
  useCreateAdminUserSchoolMutation,
  useUpdateAdminUserSchoolMutation,
  useDeleteAdminUserSchoolMutation,
} = adminUserSchoolApi;

export default adminUserSchoolApi;
export { adminUserSchoolApi };
